import { render, staticRenderFns } from "./TaxonomyForm.vue?vue&type=template&id=78d3c429&"
import script from "./TaxonomyForm.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports